import { hot } from 'react-hot-loader';
import React, { useState, useEffect, Fragment } from "react";
import translations from "../../translations";
import { createTranslations } from "react-ridge-translations";
import Listbox from "../Listbox";
import TextInput from "../TextInput";
import ResultList from "../ResultList";

import {
	getTopicsFromInputData,
	getFirstYearFromInputData,
	getLastYearFromInputData,
	filter,
	sortByFromDate,
	removePastItems,
} from "../../filter";

const Form = (props) => {
	const {
		language = 'en',
		hasImages = false,
		hasMonthSelection = false,
		hasTopicSelection = false,
		hasPastItems = true,
		items = [],
		itemDisplayOrder = 'desc',
	} = props;

	const [ translate ] = useState(createTranslations()(translations, { language: language, fallback: 'en' }));
	const t = translate.use();
	useEffect(() => {
		return () => {
			translate.setOptions([ { language: language, fallback: 'en' } ]);
		};
	}, [ translate, language ]);

	const [ filteredData, setFilteredData ] = useState(items);
	const [ firstYear ] = useState(getFirstYearFromInputData(items));
	const [ lastYear ] = useState(getLastYearFromInputData(items));
	const yearOptions = (lastYear >= firstYear) ? Array(lastYear - firstYear + 1).fill().map((_, index) => firstYear + index) : [];

	const topicOptions = getTopicsFromInputData(items).sort();
	const isFiltered = filteredData !== items;

	// remove past items from list
	// but only if the user did not use any filters
	let displayData = filteredData;
	if (! isFiltered && ! hasPastItems) {
		displayData = removePastItems(filteredData);
	}

	const [ textInput, setTextInput ] = useState("");
	const [ timespan, setTimespan ] = useState(false);
	const [ topic, setTopic ] = useState(false);
	const [ year, setYear ] = useState(false);
	const [ month, setMonth ] = useState(false);
	const [ currentPage, setCurrentPage ] = useState(0);
	
	const onReset = () => {
		setTextInput("");
		setTimespan(false);
		setTopic(false);
		setYear(false);
		setMonth(false);
		setFilteredData(items);
		setCurrentPage(0);
	};

	const onSubmit = () => {
		if (textInput === "" && topic === false && timespan === false && year === false) {
			return;
		}
		setFilteredData(
			filter(
				textInput,
				topic,
				timespan,
				yearOptions[ year ],
				month,
				items
			)
		);
		setCurrentPage(0);
	};

	return (
		<div className="pt-react-teaserlist-form">
			<form className="searchwindow opensearchserver.ignore" onSubmit={ e => e.preventDefault() }>
				<h2>{ t.form.header }</h2>
				<div className="oss-form-inline" autoComplete="off">
					<div className="row">
						<TextInput
							label={ t.textInput.label }
							placeholder={ t.textInput.placeholder }
							value={ textInput }
							onChange={ setTextInput }
							onEnter={ onSubmit }
						/>
					</div>
					<div className="row">
						{ hasTopicSelection &&
							<Listbox
								label={ t.listboxTopic.label }
								placeholder={ t.listboxTopic.placeholder }
								selectedIndex={ topic }
								options={ topicOptions }
								onChange={ setTopic }
							/>
						}
						{ hasMonthSelection ?
							<Fragment>
								<Listbox
									label={ t.listboxYear.label }
									placeholder={ t.listboxYear.placeholder }
									options={ yearOptions }
									selectedIndex={ year }
									onChange={ setYear }
								/>
								<Listbox
									label={ t.listboxMonth.label }
									placeholder={ t.listboxMonth.placeholder }
									options={ t.general.months }
									selectedIndex={ month }
									onChange={ setMonth }
									disabled={ year === false }
									labelDisabled={ t.listboxMonth.labelDisabled }
								/>
							</Fragment>
							:
							<Listbox
								label={ t.listboxTimespan.label }
								placeholder={ t.listboxTimespan.placeholder }
								selectedIndex={ timespan }
								options={ t.listboxTimespan.options }
								onChange={ setTimespan }
							/>
						}
					</div>
					<div className="row btn-row">
						<button type="submit"
							className="oss-button-inline"
							onClick={ onSubmit }
							aria-label={ t.form.submitBtnAriaLabel }
						>{ t.form.submitBtn }
						</button>
						{ isFiltered &&
							<button
								type="reset"
								className="oss-button-inline"
								onClick={ onReset }
								aria-label={ t.form.resetBtnAriaLabel }
							>{ t.form.resetBtn }
							</button>
						}
					</div>
				</div>
			</form>
			<ResultList
				teasers={ sortByFromDate(displayData, itemDisplayOrder === 'asc') }
				teasersPerPage={ 10 }
				currentPage={ currentPage }
				onPageChange={ page => setCurrentPage(page.selected) }
				showResultCount={ isFiltered }
				labelReadMore={ t.resultList.labelReadMore }
				labelResultCountSingular={ t.resultList.labelResultCountSingular }
				labelResultCountPlural={ t.resultList.labelResultCountPlural }
				labelNoResults={ t.resultList.labelNoResults }
				labelPrevious={ t.resultList.labelPrevious }
				labelNext={ t.resultList.labelNext }
				ariaLabelPage={ t.resultList.ariaLabelPage }
				hasImages={ hasImages }
			/>
		</div>
	);
};

export default hot(module)(Form);
